import { useContext } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Footer } from "../components/Footer";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import { AuthContext } from "../contexts/auth";

function Dashboard() {

  const {logout} = useContext(AuthContext)
  return (
    <>
    <Helmet>
        <title>Dashboard - Coluço System</title>
    </Helmet>
      <div id="wrapper">

        <Header active="dashboard" />

        <div id="content-wrapper" className="d-flex flex-column">

          <div id="content">

            <Navbar />

            <div className="container-fluid">

              <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Dashboard</h1>
                <button onClick={() => logout()} className="d-none d-sm-inline-block btn btn-sm btn-danger shadow-sm"><i
                  className="fas fa-sign-out-alt fa-sm text-white-50"></i> Sair</button>
              </div>

              <div className="row">
                <div className="col-lg-3 mb-4">
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Novo Paciente</h6>
                    </div>
                    <div className="card-body d-flex flex-column text-center justify-content-center">
                      <i className="fas fa-user-alt fa-3x "></i>
                      <Link to="/patients/new" className="btn btn-primary mt-4">Adicionar</Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mb-4">
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Novo Atendimento</h6>
                    </div>
                    <div className="card-body d-flex flex-column text-center justify-content-center">
                      <i className="fas fa-calendar-plus fa-3x "></i>
                      <Link to="/treatments/new" className="btn btn-primary mt-4">Adicionar</Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 mb-4">
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Novo Exame</h6>
                    </div>
                    <div className="card-body d-flex flex-column text-center justify-content-center">
                      <i className="fas fa-file-medical-alt fa-3x "></i>
                      <Link to="/exams/new" className="btn btn-primary mt-4">Adicionar</Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-3 mb-4">
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Pacientes</h6>
                    </div>
                    <div className="card-body d-flex flex-column text-center justify-content-center">
                      <i className="fas fa-users fa-3x "></i>
                      <Link to="/patients" className="btn btn-primary mt-4">Visualizar</Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mb-4">
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Atendimentos</h6>
                    </div>
                    <div className="card-body d-flex flex-column text-center justify-content-center">
                      <i className="fas fa-calendar fa-3x "></i>
                      <Link to="/treatments" className="btn btn-primary mt-4">Visualizar</Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mb-4">
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Exames</h6>
                    </div>
                    <div className="card-body d-flex flex-column text-center justify-content-center">
                      <i className="fas fa-file-medical-alt fa-3x "></i>
                      <Link to="/exams" className="btn btn-primary mt-4">Visualizar</Link>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <Footer />

        </div>

      </div>
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
    </>

  );
}

export default Dashboard;
